import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import { FdnsService } from 'src/app/services/fdns.service';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { ReferenceLibraryService } from 'src/app/services/referenceLibrary.service';
import { ApiServicesService } from '../../beneficiary/services/api-services.service';
import moment from 'moment';
import * as errorUtils from "src/app/modules/utility/global-utils";
import * as RolesRouteMap from '../../../data/constants/roles';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-manage-fdns-visit',
  templateUrl: './manage-fdns-visit.component.html',
  styleUrls: ['./manage-fdns-visit.component.scss']
})
export class ManageFdnsVisitComponent implements OnInit, OnDestroy {
  fdnsVisitForm: FormGroup;
  petitionerCompanyList: any;
  beneficiaryList: any[];
  beneficiaryParamPayload = {
    "pageNumber": 1,
    "recordsPerPage": 100,
    "searchCriteria": "beneficiary",
    "searchText": "",
    "sortBy": "companyName",
    "sortOrder": "asc",
    "status": ["ACTIVE"]  //IM-3352 (IM-3335) user story
  };
  selectedBeneficiary: any = {};
  visaTypes: ReferenceLibrary[];
  petitionTypes: ReferenceLibrary[];
  modeOfVisitTypes: ReferenceLibrary[];
  visitStatusList: ReferenceLibrary[];
  originalStatusList: ReferenceLibrary[];
  visitLocations: ReferenceLibrary[];
  // destroy$ = new Subject<void>();
  fdnsVisitId: any;
  fdnsVisitData: any;
  showBeneficiaryDetailsSection: boolean = true;
  fileConfigurations = {
    beneficiaryId: 0,
    fdnsVisitId: '',
    fileCategoryId: 231,
    fileRefCode: 'OTHER'

  };
  selectedbeneDetails: any;




  constructor(private fb: FormBuilder, private petitionerService: PetitionerService, private apiService: ApiServicesService, private referenceLibraryService: ReferenceLibraryService, private router: Router,
    private route: ActivatedRoute, private fdnsService: FdnsService, protected store: Store<any>, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.fdnsVisitForm = this.fb.group({
      id: [],
      visitDate: ['', Validators.required],
      companyId: ['', Validators.required],
      companyName: [''],
      visitLocationCode: ['', Validators.required],
      visitOfficerName: ['', Validators.required],
      modeOfVisitCode: ['', Validators.required],
      beneficiaryId: ['', Validators.required],
      visitOutcomeStatusCode: [Validators.required],
      petitionTypeCode: ['', Validators.required],
      visaTypeCode: ['', Validators.required],
      visitSummary: [''],
      jobTitle: ['', Validators.required],
      visitRelatedToCode: ["BEN", Validators.required]

    });
    this.getRefrenceLibraryData();




    this.route.params.subscribe((params) => {
      // console.log("$$$ oninit",params);
      this.fdnsVisitId = params['id'];
      this.fileConfigurations.fdnsVisitId = this.fdnsVisitId;
      if (this.fdnsVisitId) {
        this.getFdnsInfo(this.fdnsVisitId);
      }

    });

    this.fdnsVisitForm.statusChanges.subscribe(() => {
      if (this.fdnsVisitForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({ dirty: true }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
      }
    });



  }

  getRefrenceLibraryData() {


    this.referenceLibraryService.getReferenceData('VISITMODE').subscribe((response: ReferenceLibrary[]) => {
      this.modeOfVisitTypes = response;
    });

    this.referenceLibraryService.getReferenceData('VISITOUTCM').subscribe((response: ReferenceLibrary[]) => {
      this.visitStatusList = response;
      this.originalStatusList = response;
      if (!this.fdnsVisitId) {
        this.fdnsVisitForm.patchValue({
          "visitOutcomeStatusCode": "OPEN"
        })
      }
    });

    this.referenceLibraryService.getReferenceData('VISITLOC').subscribe((response: ReferenceLibrary[]) => {
      this.visitLocations = response;
    });


    this.getPetitionerCompanyList();
  }
  getPetitionerCompanyList() {
    this.petitionerService.getPetitionerClientList(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
      this.petitionerCompanyList = data;
    });
  }

  getBeneficiaryList(companyId) {
    this.fdnsService.getFdnsBeneListByCompanyId(companyId).subscribe((data: Array<any>) => {
      if (data) {
        this.beneficiaryList = data;
        if (this.fdnsVisitId && this.fdnsVisitData.beneficiaryId) {
          this.fdnsVisitForm.patchValue({
            "beneficiaryId": this.fdnsVisitData.beneficiaryId
          });

          this.onChangeBeneficiary();
          this.fileConfigurations.beneficiaryId = this.fdnsVisitData.beneficiaryId;
        }
      } else {
        this.beneficiaryList = [];
      }
    });
  }

  onChangeBeneficiary() {

    this.resetPetitionVisaValue();
    const beneId = this.fdnsVisitForm.get('beneficiaryId').value;
    this.selectedbeneDetails = this.beneficiaryList.find(item => item.beneficiaryId === beneId);
    // console.log("this.selectedbeneDetails",this.selectedbeneDetails)
    this.referenceLibraryService.getReferenceData('VISATYP').subscribe((response: ReferenceLibrary[]) => {
      this.visaTypes = response ? response : [];
      this.visaTypes = this.visaTypes.filter(item => item.name === this.selectedbeneDetails.visaType)
      if (this.fdnsVisitId && this.fdnsVisitData.visaTypeCode) {
        this.fdnsVisitForm.patchValue({
          "visaTypeCode": this.fdnsVisitData.visaTypeCode
        });
      }
    });

    this.referenceLibraryService.getReferenceData('PETTYP').subscribe((response: ReferenceLibrary[]) => {
      this.petitionTypes = response ? response : [];
      this.petitionTypes = this.petitionTypes.filter(item => item.name === this.selectedbeneDetails.petitionType)
      if (this.fdnsVisitId && this.fdnsVisitData.petitionTypeCode) {
        this.fdnsVisitForm.patchValue({
          "petitionTypeCode": this.fdnsVisitData.petitionTypeCode
        });
      }
    });



  }

  getFdnsInfo(id) {
    this.fdnsService.getFdnsVisitById(id).subscribe((response) => {
      if (response) {
        this.fdnsVisitData = response;
        // console.log("EDit FDNS", response);
        this.fileConfigurations.beneficiaryId = response.beneficiaryId ? response.beneficiaryId : 0;
        this.showBeneficiaryDetailsSection = response.visitRelatedToCode != 'PETNR' ? true : false;
        this.getBeneficiaryList(response.companyId)
        this.fdnsVisitForm.patchValue({
          id: response.id,
          visitDate: new Date(response.visitDate),
          companyId: response.companyId,
          companyName: response.companyName,
          visitLocationCode: response.visitLocationCode,
          visitOfficerName: response.visitOfficerName,
          modeOfVisitCode: response.modeOfVisitCode,
          beneficiaryId: response.beneficiaryId,
          visitOutcomeStatusCode: response.visitOutcomeStatusCode,
          petitionTypeCode: response.petitionTypeCode,
          visaTypeCode: response.visaTypeCode,
          visitSummary: response.visitSummary,
          jobTitle: response.jobTitle,
          visitRelatedToCode: response.visitRelatedToCode
        });

        this.handleDateValueChanges();
        this.setDynamicValidators();

      }

    });
  }
  saveFdnsVisit() {
    const payload: any = this.fdnsVisitForm.value;
    if (!this.showBeneficiaryDetailsSection) {
      delete payload.beneficiaryId;
      delete payload.petitionTypeCode;
      delete payload.visaTypeCode;
      delete payload.jobTitle;
    }
    payload.visitDate = payload.visitDate ? moment(payload.visitDate).format('MM-DD-YYYY') : null;
    this.fdnsService.createFdnsVisit(payload).subscribe((response: any) => {
      // console.log("response", response);
      if (response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.fdnsVisitId = response.data.id;
        this.fileConfigurations.fdnsVisitId = this.fdnsVisitId;
        this.fileConfigurations.beneficiaryId = response.data.beneficiaryId ? response.data.beneficiaryId : 0;
        this.fdnsVisitForm.reset({
          ...this.fdnsVisitForm.value,
          'id': this.fdnsVisitId
        });
      }
    });


  }
  onChangeCompanyName() {
    let companyId = this.fdnsVisitForm.get('companyId').value;
    this.fdnsVisitForm.patchValue({
      "beneficiaryId": '',
      "petitionTypeCode": '',
      "visaTypeCode": ''
    });
    const item = this.fdnsVisitForm.get('beneficiaryId')
    item.markAsPristine();
    item.markAsUntouched();
    item.updateValueAndValidity();
    this.resetPetitionVisaValue();
    this.getBeneficiaryList(companyId)

  }


  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }
  backToList() {
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/companies/compliance/compliance/fdns-visit`]);
    // this.router.navigate(['../fdns-visit'], { relativeTo: this.route });

  }
  changeInVisitRelates() {
    this.showBeneficiaryDetailsSection = (this.fdnsVisitForm.get('visitRelatedToCode').value != "PETNR") ? true : false;
    this.setDynamicValidators();

  }
  setDynamicValidators() {
    const beneficiaryIdControl = this.fdnsVisitForm.get('beneficiaryId');
    const petitionTypeCodeControl = this.fdnsVisitForm.get('petitionTypeCode');
    const visaTypeCodeControl = this.fdnsVisitForm.get('visaTypeCode');
    const jobTitleControl = this.fdnsVisitForm.get('jobTitle');
    const fdnsVisitFor = this.fdnsVisitForm.get('visitRelatedToCode').value;
    let controlArr = [beneficiaryIdControl, petitionTypeCodeControl, visaTypeCodeControl, jobTitleControl]

    for (var item of controlArr) {
      if (fdnsVisitFor === 'PETNR') {
        item.setValidators(null);
      } else {
        item.setValidators([Validators.required]);
        item.markAsUntouched()
      }
      item.updateValueAndValidity();

    }
    //  console.log("$$$$$",this.fdnsVisitForm)

  }

  resetPetitionVisaValue() {
    this.fdnsVisitForm.patchValue({
      "petitionTypeCode": '',
      "visaTypeCode": ''
    });
    const petitionTypeCodeControl = this.fdnsVisitForm.get('petitionTypeCode');
    const visaTypeCodeControl = this.fdnsVisitForm.get('visaTypeCode');
    let controlArr = [petitionTypeCodeControl, visaTypeCodeControl]

    for (var item of controlArr) {
      item.markAsPristine();
      item.markAsUntouched();
      item.updateValueAndValidity();

    }

  }

  fileUploadSuccess() {
    //this.getLicense();
  }
  handleDateValueChanges() {
    let visitDate = this.fdnsVisitForm.get('visitDate').value;
    let today = new Date();
    if (new Date(visitDate) >= new Date(today)) {
      this.visitStatusList = this.visitStatusList.filter(ele => ele.code != 'CLOSED')
    } else {
      this.visitStatusList = this.originalStatusList;
    }
    // console.log("date",this.fdnsVisitForm.get('visitDate').value, today)
  }
  ngOnDestroy() {
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }

}
